import { render, staticRenderFns } from "./MyExpense.vue?vue&type=template&id=0b7c0e84&scoped=true&"
import script from "./MyExpense.vue?vue&type=script&lang=js&"
export * from "./MyExpense.vue?vue&type=script&lang=js&"
import style0 from "./MyExpense.vue?vue&type=style&index=0&id=0b7c0e84&lang=less&scoped=true&"
import style1 from "./MyExpense.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7c0e84",
  null
  
)

export default component.exports